import MediatorScoreStatistics from "./mediators/MediatorScoreStatistics";
import {operationNames, userHasAccess} from "../data/pages";

const Home = () => {
    return <div>
        {userHasAccess(operationNames.VIEW_PRESCRIPTION_STATISTICS) && <MediatorScoreStatistics/>}
    </div>
}
export default Home;